import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { pick } from "./paymentGatewayUtils";
import { toJalaliFullDate } from "../../middleware/middleware";

const STEPS = [
  { key: "started", label: "شروع پرداخت", field: "startedAt", pascal: "StartedAt" },
  { key: "callback", label: "ثبت بازگشت از بانک", field: "callbackAt", pascal: "CallbackAt" },
  { key: "verified", label: "بررسی تراکنش", field: "verifiedAt", pascal: "VerifiedAt" },
  { key: "settled", label: "ثبت نهایی پرداخت", field: "settledAt", pascal: "SettledAt" },
  { key: "completed", label: "تکمیل پرداخت", field: "completedAt", pascal: "CompletedAt" },
];

const PaymentTimeline = ({ timeline }) => {
  if (!timeline) return null;

  const visibleSteps = STEPS.map((step) => ({
    ...step,
    at: pick(timeline, step.field, step.pascal),
  })).filter((step) => step.at);

  if (visibleSteps.length === 0) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
        مراحل پرداخت
      </Typography>
      <Stack spacing={1.25}>
        {visibleSteps.map((step, index) => {
          const isLast = index === visibleSteps.length - 1;
          return (
            <Stack key={step.key} direction="row" spacing={1.25} alignItems="flex-start">
              {isLast ? (
                <CheckCircleOutlineIcon color="success" fontSize="small" sx={{ mt: 0.25 }} />
              ) : (
                <CheckCircleOutlineIcon color="primary" fontSize="small" sx={{ mt: 0.25 }} />
              )}
              <Box>
                <Typography variant="body2" fontWeight={600}>
                  {step.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {toJalaliFullDate(step.at)}
                </Typography>
              </Box>
            </Stack>
          );
        })}
      </Stack>
      {visibleSteps.length < STEPS.length ? (
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1, opacity: 0.6 }}>
          <RadioButtonUncheckedIcon fontSize="small" />
          <Typography variant="caption" color="text.secondary">
            مراحل بعدی پس از تکمیل پرداخت نمایش داده می‌شوند.
          </Typography>
        </Stack>
      ) : null}
    </Box>
  );
};

PaymentTimeline.propTypes = {
  timeline: PropTypes.object,
};

export default PaymentTimeline;
